import { render, staticRenderFns } from "./FieldVehicleType.vue?vue&type=template&id=ef6c163c&"
import script from "./FieldVehicleType.vue?vue&type=script&lang=js&"
export * from "./FieldVehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef6c163c')) {
      api.createRecord('ef6c163c', component.options)
    } else {
      api.reload('ef6c163c', component.options)
    }
    module.hot.accept("./FieldVehicleType.vue?vue&type=template&id=ef6c163c&", function () {
      api.rerender('ef6c163c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldVehicleType.vue"
export default component.exports